import { Box, Card, Grid, TextField } from "@mui/material";
import { useEffect } from "react";
import ImageIcon from "@mui/icons-material/Image";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import GifIcon from "@mui/icons-material/Gif";
import MovieIcon from "@mui/icons-material/Movie";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SuggestionSimulatorComponent from "./SuggestionSimulatorComponent";
import { DYNAMIC_URL_REGEX } from "../../../../constants";

export default function MediaCardDetailsComponent({ mediaCardCarouselDetails }) {
    const getMediaIcons = fileType => {
        if (!fileType) return <InsertDriveFileIcon />;

        const lowerType = fileType.toLowerCase();

        // if (["jpeg", "jpg", "png"].some(ext => lowerType.includes(ext))) {
        //     return <ImageIcon />;
        // }

        // if (["mp3", "mp4"].some(ext => lowerType.includes(ext))) {
        //     return <MusicNoteIcon />;
        // }

        // if (["gif"].some(ext => lowerType.includes(ext))) {
        //     return <GifIcon />;
        // }

        // if (["mepg"].some(ext => lowerType.includes(ext))) {
        //     return <MovieIcon />;
        // }

        if (["pdf"].some(ext => lowerType.includes(ext))) {
            return <PictureAsPdfIcon />;
        }
    };
    return (
        <>
            <Grid padding={"10px"} width={"100%"}>

                {mediaCardCarouselDetails.direction === "pdf_at_top" && (
                    <>
                        {mediaCardCarouselDetails.media.url && (
                            <Box sx={{ mt: 1, ml: 3, color: "#333", fontWeight: 500 }}>
                                {getMediaIcons(mediaCardCarouselDetails.media.type)}

                                {mediaCardCarouselDetails.media.url.match(DYNAMIC_URL_REGEX) ?
                                    <>
                                        [Variable]
                                    </>
                                    :
                                    mediaCardCarouselDetails?.media?.fileName
                                }
                            </Box>
                        )}
                    </>
                )}
                <TextField
                    multiline
                    size="small"
                    fullWidth
                    label={null}
                    variant="outlined"
                    value={mediaCardCarouselDetails.mediaContent}
                    sx={{
                        pointerEvents: "none",
                        backgroundColor: "transparent",
                        "& .MuiInputBase-root": {
                            border: "none",
                        },
                        "& .MuiInputBase-inputMultiline": {
                            padding: 0,
                        },
                        margin: 1,
                        fontSize: "0.875rem",
                        color: "black",
                    }}
                />
                {mediaCardCarouselDetails.direction === "text_message_at_top" && (
                    <>
                        {mediaCardCarouselDetails.media.url && (
                            <Box sx={{ mt: 1, ml: 3, color: "#333", fontWeight: 500 }}>
                                {getMediaIcons(mediaCardCarouselDetails.media.type)}
                                {mediaCardCarouselDetails.media.url.match(DYNAMIC_URL_REGEX) ?
                                    <>
                                        [Variable]
                                    </>
                                    :
                                    mediaCardCarouselDetails?.media?.fileName
                                }
                            </Box>
                        )}
                    </>
                )}



                <Grid container mt={"15px"}>
                    {mediaCardCarouselDetails?.suggestionsList?.map(suggestions => (
                        <Grid item sx={{ border: "1px solid Grey", borderRadius: "50px" }} padding={1} paddingInline={3} margin={1}>
                            <SuggestionSimulatorComponent suggestion={suggestions} />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </>
    );
}
